import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Article,
  ArticleSearch,
  OCC_ENDPOINTS,
  OccArticle,
  OccArticleField,
  OccArticleSearchParams,
  OccArticlesByProductCode,
  OccArticlesSearchResponse,
  ProductArticles,
} from '@article/const';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class OccArticlesService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  loadList(params?: OccArticleSearchParams): Observable<ArticleSearch> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.articlesSearch, { queryParams: params });

    return this.http
      .get<OccArticlesSearchResponse>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.articlesSearch),
      })
      .pipe(map((response) => ({ ...response, results: response.results })));
  }

  load(articleCode: string): Observable<Article> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.articleDetail, { urlParams: { articleCode } });

    return this.http.get<Article>(url, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.articleDetail),
    });
  }

  loadListByProductCode(productCode: string): Observable<ProductArticles> {
    const fields: OccArticleField[] = ['code', 'name', 'picture', 'publishDate'];
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.articles, {
      queryParams: { productCode, fields: fields.join(',') },
    });

    return this.http
      .get<OccArticlesByProductCode>(url, {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.articles),
      })
      .pipe(map((response) => ({ results: response.articles })));
  }

  saveRating(articleCode: string, rate: number): Observable<Article> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.saveRating);

    return this.http.post<OccArticle>(
      url,
      { articleCode, rate },
      {
        context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.saveRating),
      },
    );
  }
}
